import { render, staticRenderFns } from "./CastDetails.vue?vue&type=template&id=0610fbcc&scoped=true&"
import script from "./CastDetails.vue?vue&type=script&lang=js&"
export * from "./CastDetails.vue?vue&type=script&lang=js&"
import style0 from "./CastDetails.vue?vue&type=style&index=0&id=0610fbcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0610fbcc",
  null
  
)

export default component.exports